import styled from "styled-components";

const LabelWrapper = styled.div`
  font-size: 12px;
  color: ${(props) => `${props.severity === "alert" ? "red" : "green"}`};
  margin-top: 5px;
`;

const CustomAlertLabel = ({ message, severity = "alert" }) => {
  return <LabelWrapper severity={severity}>{message}</LabelWrapper>;
};

export default CustomAlertLabel;
